export default 'Éclairage public LED et télégestion : baisse de consommation, primes CEE et montage de dossier pour communes. Audit et devis avec aides intégrées.';
